import { render, staticRenderFns } from "./TheMessageBox.vue?vue&type=template&id=65158227"
import script from "./TheMessageBox.vue?vue&type=script&lang=js"
export * from "./TheMessageBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports